import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", { d: "M10.095 6.2c0-1.01-.83-1.7-2.08-1.7-1.34 0-2.1.75-2.12 1.84h1.18c.03-.48.36-.79.86-.79s.83.29.83.69c0 .4-.17.61-.73.95-.61.36-.85.75-.78 1.45v.24h1.16v-.23c0-.42.16-.63.74-.97.62-.37.94-.82.94-1.48Zm-1.41 4.74c0-.46-.38-.84-.84-.84-.46 0-.84.38-.84.84 0 .46.38.84.84.84.46 0 .84-.38.84-.84Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M4.545 14.94c1.07.53 2.25.81 3.45.81 4.27 0 7.75-3.48 7.75-7.75S12.265.25 7.995.25.245 3.73.255 8c0 1.56.45 3.05 1.32 4.33l-.78 2.1c-.1.25-.05.53.12.74.17.2.44.3.7.26l2.93-.49Zm.49-1.44a.768.768 0 0 0-.36-.09l-.02.01h-.12l-1.9.32.47-1.26a.75.75 0 0 0-.1-.71 6.252 6.252 0 0 1 4.99-10.02c3.45 0 6.26 2.8 6.26 6.25a6.252 6.252 0 0 1-9.22 5.5Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  l,
  n
];
function s(d, h) {
  return t(), c("svg", o, [...r]);
}
const p = { render: s };
export {
  p as default,
  s as render
};
